import React from 'react';
// import { UiSecretDiscussPage } from './SecretDiscussPage.style';
import { HomeGroupLayout, SecretDiscuss } from 'components';

/**
 * 導師商談頁面
 */

export const SecretDiscussPage = () => {
  return (
    <HomeGroupLayout>
      <SecretDiscuss />
    </HomeGroupLayout>
  );
};

